import { AxiosApi } from "api"
import { Country, DropDownItem } from "interface/common"

export async function getFishingDepartmentIdNumbersApi(id: number) {
    const apiUrl = "api/ReportSearch/FishingDepartmentIdNumber"

    try {
        const departmentNumbers = await AxiosApi.get<DropDownItem[]>(apiUrl, {
            params: {
                id
            }
        })

        return departmentNumbers.data
    } catch (error) {
        throw error
    }
}

export async function getSearchUsageApi(text?: string) {
    const apiUrl = "api/ReportSearch/usage"

    try {
        const usageItems = await AxiosApi.get<DropDownItem[]>(apiUrl, {
            params: {
                text
            }
        })
        return usageItems.data
    } catch (error) {
        throw error
    }
}

export async function getFoodSafetyApprovalNumberApi(locationId?: number) {
    const apiUrl = "api/ReportSearch/FoodSafetyApprovalNumber"

    try {
        const approvalNumbers = await AxiosApi.get<DropDownItem[]>(apiUrl, {
            params: {
                locationId
            }
        })
        return approvalNumbers.data
    } catch (error) {
        throw error
    }
}

export async function getSearchBusinessNumberApi(id?: string) {
    const apiUrl = "api/ReportSearch/BusinessNumber"

    try {
        const businessNumbers = await AxiosApi.get<DropDownItem[]>(apiUrl, {
            params: {
                id
            }
        })
        return businessNumbers.data
    } catch (error) {
        throw error
    }
}

export async function getCountriesApi() {
    const apiUrl = "api/ReportSearch/countries"

    try {
        const countries = await AxiosApi.get<Country[]>(apiUrl, {
            params: {
                
            }
        })
        return countries.data
    } catch (error) {
        throw error
    }
}

export async function getCountryByCodeApi(code?: string) {
    const apiUrl = "api/ReportSearch/country"

    try {
        const country = await AxiosApi.get<Country>(apiUrl, {
            params: {
                code
            }
        })
        return country.data
    } catch (error) {
        throw error
    }
}